export default {
  saveRef: function saveRef(name) {
    var _this = this;

    return function (node) {
      _this[name] = node;
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/.9.2.5@rc-tabs/es/RefMixin.js
// module id = 628
// module chunks = 1